export default __webpack_public_path__ + "static/media/1.8246d5ed.svg";